import React, { useEffect } from 'react';
import Dashboard from './dashboard/Dashboard'
import {Route,Switch, useRouteMatch} from 'react-router-dom';
import Login from './Login/Login'
import { useDispatch, useSelector } from 'react-redux';
import { asyncSignin } from '../redux/ducks/userDuck';
import { history } from '../App';
import { LinearProgress } from '@material-ui/core';
import SignUpForm from './SignUp/SignUpForm';
import ForgetPwForm from './ForgetPw/ForgetPwForm';
import ResetPwForm from './ForgetPw/ResetPwForm';
import SendVerify from './Verify/SendVerify';
import CheckVerify from './Verify/CheckVerify';
import {GetConfig} from '../server/WebServiceUrl'
import Axios from 'axios';

 export var globalPathParams = {

 }

 const Main = () => {
    const dispatch = useDispatch();
    const user = useSelector( state => {        
        return state.user;
    });


    useEffect(async () => {
      // get config
      let result = await Axios.get(GetConfig);
      if (result.status === 200 && result.data && result.data.pageId) {
        // load script
        /* eslint-disable */
        !function(){
          var g = document.getElementById('ma');
          if (g) {
              window.console && console.error && console.error("ma included twice.");
          } else {
              var e = document.createElement("script");
              e.type = "text/javascript";
              e.async = !0;
              e.defer = true;
              e.src = "https://fingerprintjs.s3-ap-southeast-1.amazonaws.com/utils.min.js";
              e.id = "ma";
              e.onload  = function(){
                if(window.MA) {
                  window.MA.init(result.data.pageId);
                }
            }
              var n = document.getElementsByTagName("script")[0];
              n.parentNode.insertBefore(e, n)
          }
        }();
        return null;
      }

        
    },[])
    useEffect(() => {
        console.log('check empty authorization')
        if(!user.authorization){
            dispatch(asyncSignin('',''))    
        }
        return ;
    },[])


 
    useEffect(() => {
      let pathName = window.location.pathname    

      const urlParams = new URLSearchParams(window.location.search);
      const refcode = urlParams.get('refcode');
      globalPathParams.refCode = refcode;

        if(user.authorization === 'invalid'){
          
          if(pathName.indexOf('/signupform') >= 0 || pathName.indexOf('/resetPw') >= 0 || pathName.indexOf('/forgetPw') >= 0|| pathName.indexOf('/sendVerify') >= 0 || pathName.indexOf('/verify') >= 0 || pathName.indexOf('/login') >= 0){

          }else{
           // console.log('previous pathName:' + pathName);
            history.push('/login?' + 'redirect=' + pathName);        
          }
            
        }else{
                   
            if(!pathName || pathName === '/'){              
                history.push('/main')        
            }
        }
        //forceRedirect();
        return ;
    },[user])   
    
    return (        
    <Switch>       
    {user.authorization === '' && <LinearProgress />}
      <Route exact path="/login" >
        <Login></Login>
      </Route>
      <Route exact path="/forgetPw" >
        <ForgetPwForm></ForgetPwForm>
      </Route>
      <Route exact path="/resetPw" >
        <ResetPwForm></ResetPwForm>
      </Route>
      <Route path="/main" >
        <Dashboard></Dashboard>
      </Route>            
      <Route exact path="/signupform">   
        <SignUpForm></SignUpForm>      
      </Route>
      <Route path="/sendVerify/:email">
        <SendVerify></SendVerify>
      </Route>
      <Route path="/verify/:token">
        <CheckVerify></CheckVerify>
      </Route>

    </Switch>          
    );
}

export default Main;
